<ng-template #defaultTemplate let-option
  ><span>{{ getLabel(option) }}</span></ng-template
>

<div class="input-radio" [style.margin-bottom]="messagePad">
  <div class="p-field">
    <div *ngFor="let option of options; let i = index" class="container">
      <label [for]="getOptionId(i)">
        <input
          #input
          appReadOnly
          type="radio"
          [ignoreReadOnly]="ignoreReadOnly"
          [id]="getOptionId(i)"
          [name]="name"
          [value]="option"
          [(ngModel)]="selectedItem"
          [disabled]="isDisabled"
          (click)="onValueChange(option)"
          #model="ngModel"
          [class.has-errors]="hasErrors"
          [attr.aria-invalid]="hasErrors"
          [attr.aria-describedby]="hasErrors ? name + '-error' : null"
        />
        <ng-container
          [ngTemplateOutlet]="optionTemplate || defaultTemplate"
          [ngTemplateOutletContext]="{ $implicit: option, index: i }"
        >
        </ng-container>
      </label>
    </div>
    <div class="error-container" role="alert" [attr.id]="name + '-error'" aria-atomic="true">
      <span *ngFor="let error of errors" class="p-error">{{ error }}</span>
    </div>
  </div>
</div>
